export default {
	title: "Frases de Sabedoria",
	text: "Frase",
	author: "Autor",
	isActive: "Ativo",
	create: "Nova Frase",
	edit: "Editar Frase",
	searchPlaceholder: "Buscar frases...",
	noData: "Nenhuma frase cadastrada",
	noDataSubtext: "Adicione frases de sabedoria personalizadas para o seu templo",
	confirmDeleteMessage: "Tem certeza que deseja excluir esta frase? Esta ação não pode ser desfeita.",
	stats: {
		total: "Total",
		active: "Ativas",
	},
	form: {
		text: "Frase",
		author: "Autor",
	},
	validation: {
		textMaxLength: "A frase deve ter no máximo 500 caracteres",
		authorMaxLength: "O autor deve ter no máximo 150 caracteres",
	},
	systemQuotes: "Sistema",
	customQuotes: "Cadastradas",
	weightHint: "Ajuste a frequência com que cada tipo de frase aparece no dashboard",
	messages: {
		createSuccess: "Frase criada com sucesso",
		updateSuccess: "Frase atualizada com sucesso",
		deleteSuccess: "Frase excluída com sucesso",
		createError: "Erro ao criar frase",
		updateError: "Erro ao atualizar frase",
		deleteError: "Erro ao excluir frase",
		loadError: "Erro ao carregar frases",
		weightSaved: "Proporção de frases salva",
		weightError: "Erro ao salvar proporção",
	},
};
